/**
 * Handles API requests with JSON responses by providing path and id
 */
export const fetcher = <T = unknown>(path: string, id?: string): Promise<T> => {
  if (!path) {
    throw new Error('Path is required');
  }

  const baseApiUrl = process.env.BASE_API_URL;
  const url = id ? `${baseApiUrl}/${path}/${id}` : `${baseApiUrl}/${path}`;

  const result = fetch(url).then((response: Response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  });

  return result;
};
